import ApiService from "./ApiService";

const TestEmailService = {
    sendEmail: async (emailData) => {
        try {
            const response = await ApiService.postData('/test/email/send-email', emailData);
            return response;
        } catch (error) {
            console.error('Error sending email:', error);
            throw error;
        }
    }
};

export default TestEmailService;
